import { useState, useEffect } from 'react';

import {
  ModalCompanyDetailInvestPay,
  DetailInvestPay,
  Recordatory,
  ExtraInfo
} from './companyDetailInvestPay.styles';

export default function CompanyDetailInvestPay(props) {
  const { listBids } = props;
  const [detailInvestPay, setDetailInvestPay] = useState(props.showModalCompanyDetailInvestPay);
  const [showExtraInfo, setShowExtraInfo] = useState(false);
  const [available] = useState(true);
  useEffect(() => {
    setDetailInvestPay(props.showModalCompanyDetailInvestPay);
  }, [props.showModalCompanyDetailInvestPay]);

  const closeModal = () => {
    setDetailInvestPay(false);
    props.setCompanyDetailInvestPay(false);
  };
  const handleClick = () => {
    if (isExpired) {
      setShowExtraInfo(!showExtraInfo);
    }
  };
  const isExpired = listBids?.campaign?.isExpired === '1';
  const isSigned = listBids?.campaign?.isPromissoryNoteSigned === '1' ? 'Firmado' : 'No firmado';
  const isSuccessful = listBids?.campaign?.isSuccessful === '0' ? 'Incompleta' : 'Exitosa';

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }

  return (
    <ModalCompanyDetailInvestPay showModalCompanyDetailInvestPay={detailInvestPay}>
      <div>
        <div>
          <h3>Campaña:{listBids?.campaign?.nombreCampania}</h3>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
        </div>
        <DetailInvestPay isExpired={isExpired}>
          <div>
            <button onClick={handleClick}>Detalle campaña finalizada:</button>
            {showExtraInfo && (
              <ExtraInfo>
                <h3>Campaña finalizada:</h3>
                <p>{isSuccessful}</p>
                <h3>Monto total recaudado de campaña:</h3>
                <p>{formatCurrency(listBids?.campaign?.collectedAmount)}</p>
                <h3>Pagaré:</h3>
                <p>{isSigned}</p>
              </ExtraInfo>
            )}
          </div>
          <div>
            <div>
              <h3>Solicitud:</h3>
              <ul>
                <li>
                  <span>Monto total solicitado de campaña:</span>
                  <p>{formatCurrency(listBids?.campaign?.montoSolicitado)}</p>
                </li>
                <li>
                  <span>Monto recaudado de campaña:</span>
                  <p>{formatCurrency(listBids?.campaign?.collectedAmount)}</p>
                </li>
                <li>
                  <span>Estado:</span>
                  <p>{listBids?.campaign?.isActive === '1' ? 'Activa' : 'Finalizada'}</p>
                </li>
                <li>
                  <span>Fecha de activación:</span>
                  <p>
                    {formatDate(listBids?.campaign?.dateStartCampaign)
                      ? formatDate(listBids?.campaign?.dateStartCampaign)
                      : '-'}
                  </p>
                </li>
                <li>
                  <span>Fecha de finalización:</span>
                  <p>
                    {formatDate(listBids?.campaign?.dateEndCampaign)
                      ? formatDate(listBids?.campaign?.dateEndCampaign)
                      : '-'}
                  </p>
                </li>
                <li>
                  <span>Destino de campaña:</span>
                  <p>Factoraje a proveedores</p>
                </li>
              </ul>
            </div>
            <div>
              <h3>Inversión:</h3>
              <ul>
                <li>
                  <span>ID inversión:</span>
                  <p>{listBids?.id}</p>
                </li>
                <li>
                  <span>Monto invertido:</span>
                  <p>
                    {formatCurrency(listBids?.compromisoInversion)
                      ? formatCurrency(listBids?.compromisoInversion)
                      : '-'}
                  </p>
                </li>
                <li>
                  <span>Tasa de interés:</span>
                  <p>
                    {listBids?.interesInversionistaPorcentaje.toFixed(2)
                      ? listBids?.interesInversionistaPorcentaje.toFixed(2)
                      : '-'}
                    %
                  </p>
                </li>
                <li>
                  <span>Intereses generados del monto total solicitado de campaña:</span>
                  <p>
                    {formatCurrency(listBids?.interesInversionistaPesos)
                      ? formatCurrency(listBids?.interesInversionistaPesos)
                      : '-'}
                  </p>
                </li>
                <li>
                  <span>Porcentaje del total invertido:</span>
                  <p>
                    {listBids?.porcentajeGananciaInteres * 100
                      ? listBids?.porcentajeGananciaInteres * 100
                      : '-'}
                    %
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <Recordatory>
            <p>
              * Recuerda que este es un monto aproximado de tu cobro final. Cuando se haya liquidado
              la campaña se verá relfejado automáticamente.
            </p>
          </Recordatory>
        </DetailInvestPay>
      </div>
    </ModalCompanyDetailInvestPay>
  );
}
